import {
	createRouter,
	createWebHistory
} from 'vue-router'
import Home from '@/views/Home.vue'
import findPdf from '@/components/findPdf.vue'
import bookATestDrive from '@/components/bookATestDrive.vue'
import disclaimer from '@/components/disclaimer.vue'
import privacyPolicy from '@/components/privacyPolicy.vue'
import userProtocol from '@/components/userProtocol.vue'
import reportOfTheft from '@/components/reportOfTheft.vue'
import customerService from '@/components/customerService.vue'
import customerHistory from '@/components/customerHistory.vue'
import customerInfo from '@/components/customerInfo.vue'
import customer from '@/components/customer.vue'
import roadRescue from '@/components/roadRescue.vue'
import memberAgreement from '@/components/memberAgreement.vue'

import serverProtocol from '@/components/protocol/serverProtocol.vue'
import childrenPrivacy from '@/components/protocol/childrenPrivacy.vue'
import userinfoCollect from '@/components/protocol/userinfoCollect.vue'
import thirdPartySharing from '@/components/protocol/thirdPartySharing.vue'
import privacyProtocol from '@/components/protocol/privacyProtocol.vue'
import index from '@/components/protocol/index.vue'


import carServerProtocol from '@/components/protocol/carManagement/carServerProtocol.vue'
import carChildrenPrivacy from '@/components/protocol/carManagement/carChildrenPrivacy.vue'
import carUserinfoCollect from '@/components/protocol/carManagement/carUserinfoCollect.vue'
import carThirdPartySharing from '@/components/protocol/carManagement/carThirdPartySharing.vue'
import carPrivacyProtocol from '@/components/protocol/carManagement/carPrivacyProtocol.vue'
import carIndex from '@/components/protocol/carManagement/carIndex.vue'

const routes = [{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/findPdf',
		name: 'findPdf',
		component: findPdf
	},
	{
		path: '/bookATestDrive',
		name: 'bookATestDrive',
		component: bookATestDrive
	},
	{
		path: '/reportOfTheft',
		name: 'reportOfTheft',
		component: reportOfTheft
	},
	{
		path: '/customerService',
		name: 'customerService',
		component: customerService
	},
	{
		path: '/customerHistory',
		name: 'customerHistory',
		component: customerHistory
	},
	{
		path: '/customerInfo',
		name: 'customerInfo',
		component: customerInfo
	},
	{
		path: '/customer',
		name: 'customer',
		component: customer
	},
	{
		path: '/roadRescue',
		name: 'roadRescue',
		component: roadRescue
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		component: disclaimer
	},
	{
		path: '/privacyPolicy',
		name: 'privacyPolicy',
		component: privacyPolicy
	},
	{
		path: '/userProtocol',
		name: 'userProtocol',
		component: userProtocol
	},
	{
		path: '/memberAgreement',
		name: 'memberAgreement',
		component: memberAgreement
	},
	{
		path: '/protocol/serverProtocol',
		name: 'serverProtocol',
		component: serverProtocol
	},
	{
		path: '/protocol/childrenPrivacy',
		name: 'childrenPrivacy',
		component: childrenPrivacy
	},
	{
		path: '/protocol/userinfoCollect',
		name: 'userinfoCollect',
		component: userinfoCollect
	},
	{
		path: '/protocol/thirdPartySharing',
		name: 'thirdPartySharing',
		component: thirdPartySharing
	},
	{
		path: '/protocol/privacyProtocol',
		name: 'privacyProtocol',
		component: privacyProtocol
	},
	{
		path: '/protocol/index',
		name: 'index',
		component: index
	},
	{
		path: '/protocol/carManagement/carIndex',
		name: 'carIndex',
		component: carIndex
	},
	{
		path: '/protocol/carManagement/carServerProtocol',
		name: 'carServerProtocol',
		component: carServerProtocol
	},
	{
		path: '/protocol/carManagement/carChildrenPrivacy',
		name: 'carChildrenPrivacy',
		component: carChildrenPrivacy
	},
	{
		path: '/protocol/carManagement/carUserinfoCollect',
		name: 'carUserinfoCollect',
		component: carUserinfoCollect
	},
	{
		path: '/protocol/carManagement/carThirdPartySharing',
		name: 'carThirdPartySharing',
		component: carThirdPartySharing
	},
	{
		path: '/protocol/carManagement/carPrivacyProtocol',
		name: 'carPrivacyProtocol',
		component: carPrivacyProtocol
	}
]

const router = createRouter({
	routes,
	history: createWebHistory(process.env.BASE_URL),
	scrollBehavior() {
		return {
			top: 0
		}
	}
})

export default router